// Sayfalama.js — SAYFALI LİSTE, TEK TİP (6 Eki 2026 · 24 ay şartı 3. adım)
//
// 🔑 Serkan (5 Eki 2026): *"sayfa başına 100 kayıt bence uygun"* · *"alışveriş sitelerindeki gibi aşağıda page number
//    koysak … page gezinme isterse bir sonraki page tıklasın"*. Liste ekranları seçilen aralığı SUNUCUDAN sayfa sayfa
//    okur; bu bileşen yalnız gezinmeyi çizer (‹ PREV · 1 2 3 … · NEXT ›). İlk kullanan FTL EDIT REPORT; öteki liste
//    ekranları da bunu çağırır (yeni sayfalama deseni yazılmaz — tek kaynak).
import React from 'react';
import { dugmeStili } from './tasarim';

export const SAYFA_BOYU = 100;

export const sayfaSayisi = (toplam, boy = SAYFA_BOYU) => Math.max(1, Math.ceil((toplam || 0) / boy));

/** Gösterilecek düğmeler: 9 sayfaya kadar hepsi; fazlasında 1 … (seçilinin ±2'si) … son. */
export function sayfaDugmeleri(sayfa, son) {
  if (son <= 9) return Array.from({ length: son }, (_, i) => i + 1);
  const orta = [];
  for (let n = Math.max(2, sayfa - 2); n <= Math.min(son - 1, sayfa + 2); n++) orta.push(n);
  return [1, ...(orta[0] > 2 ? ['…'] : []), ...orta, ...(orta[orta.length - 1] < son - 1 ? ['…'] : []), son];
}

export default function Sayfalama({ sayfa, toplam, boy = SAYFA_BOYU, onSayfa, testid = 'sayfalama' }) {
  const son = sayfaSayisi(toplam, boy);
  if (son <= 1) return null;
  const kucuk = (rol, devreDisi = false) => dugmeStili(rol, { kucuk: true, devreDisi });
  return (
    <div data-testid={testid}
         style={{ display:'flex', gap:6, justifyContent:'center', alignItems:'center', padding:'12px 16px', flexWrap:'wrap' }}>
      <button type="button" style={kucuk('notr', sayfa <= 1)} disabled={sayfa <= 1}
              onClick={() => onSayfa(sayfa - 1)} data-testid={`${testid}-onceki`}>‹ PREV</button>
      {sayfaDugmeleri(sayfa, son).map((x, i) => (x === '…'
        ? <span key={`bosluk-${i}`} style={{ color:'var(--t3)', fontFamily:'var(--mono)' }}>…</span>
        : <button type="button" key={x} style={kucuk(x === sayfa ? 'birincil' : 'notr')}
                  aria-current={x === sayfa ? 'page' : undefined}
                  onClick={() => onSayfa(x)} data-testid={`${testid}-${x}`}>{x}</button>))}
      <button type="button" style={kucuk('notr', sayfa >= son)} disabled={sayfa >= son}
              onClick={() => onSayfa(sayfa + 1)} data-testid={`${testid}-sonraki`}>NEXT ›</button>
    </div>
  );
}
